import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "manifesto", label: "Manifesto", testId: "nav-link-manifesto" },
  { id: "legacy", label: "Legacy", testId: "nav-link-legacy" },
  { id: "perks", label: "Perks", testId: "nav-link-perks" },
  { id: "gallery", label: "Gallery", testId: "nav-link-gallery" },
  { id: "faq", label: "FAQ", testId: "nav-link-faq" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? "backdrop-blur-xl bg-white/85 border-[#E2E8F0]"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="frantiger-labs-nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/frantiger-logo.png"
            alt="frantiger"
            className="h-7 w-auto transition-transform duration-300 group-hover:scale-[1.04]"
          />

          <span className="font-display tracking-tight text-lg text-[#0055FF]" style={{ fontWeight: 800 }}>
            labs
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => go(l.id)}
              className="font-mono-x text-xs uppercase tracking-[0.2em] text-[#64748B] hover:text-[#0055FF] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button
            data-testid="nav-cta-invite-campus-btn"
            onClick={() => go("apply-student")}
            className="px-5 py-2.5 border border-[#0A0D14] text-[#0A0D14] font-mono-x text-xs uppercase tracking-[0.15em] hover:bg-[#0A0D14] hover:text-white transition-colors"
          >
            Invite Us
          </button>
          <button
            data-testid="nav-cta-vibe-check-btn"
            onClick={() => go("apply")}
            className="px-5 py-2.5 bg-[#0055FF] text-white font-mono-x text-xs uppercase tracking-[0.15em] hover:bg-[#0043CC] transition-colors"
          >
            Vibe Check
          </button>
        </div>

        <button
          data-testid="nav-mobile-menu-btn"
          className="lg:hidden text-[#0A0D14]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#E2E8F0] px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`${l.testId}-mobile`}
              onClick={() => go(l.id)}
              className="text-left font-mono-x text-sm uppercase tracking-[0.2em] text-[#0A0D14]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-vibe-check-btn-mobile"
            onClick={() => go("apply")}
            className="px-5 py-3 bg-[#0055FF] text-white font-mono-x text-xs uppercase tracking-[0.15em]"
          >
            Vibe Check
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
